module.exports = __webpack_public_path__ + "img/moren.f8fa3f3f.png";